'use client';

import React, {
  createContext,
  useEffect,
  ReactNode,
  useMemo,
} from 'react';
import { LoggerData } from '@/lib/types/interfaces/LoggerData';
import { sendLoggerData } from '@/lib/api/functions';

type LoggerContextType = {
  loggerData: LoggerData;
};

const LoggerContext = createContext<LoggerContextType | undefined>(undefined);

type LoggerProviderProps = {
  loggerData: LoggerData;
  children: ReactNode;
};

export const LoggerProvider = ({
  loggerData,
  children,
}: LoggerProviderProps) => {
  useEffect(() => {
    sendLoggerData({ ...loggerData });
  }, [loggerData]);

  const contextValue = useMemo(() => ({ loggerData }), [loggerData]);

  return (
    <LoggerContext.Provider value={contextValue}>
      {children}
    </LoggerContext.Provider>
  );
};
